module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-editor', {
    staticStyle: {
      "height": "600px"
    },
    attrs: {
      "useCustomImageHandler": "",
      "editorOptions": _vm.editorSettings
    },
    on: {
      "image-added": _vm.handleImageAdded
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd632eae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/vue2Editor.vue
// module id = 2283
// module chunks = 0